import { useContext } from "react";
import CoachContext from "src/context/coachContext.js";

const useCoach = () => {
  const value = useContext(CoachContext);
  return value;
};

export default useCoach;
